import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { EssayQuestion, EssayQuestionRelease, FillInBlankQuestion, FillInBlankQuestionRelease, MatchingQuestionRelease, MultipleChoiceQuestion, MultipleChoiceQuestionRelease, QuestionType, SingleChoiceQuestion, SingleChoiceQuestionRelease, SpeakingQuestion, SpeakingQuestionRelease } from '../../../core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var QUESTION_RELEASES_API = 'QUESTION_RELEASES_API';
export var QuestionReleasesApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(QuestionReleasesApi, _AxiosApi);

  var _super = _createSuper(QuestionReleasesApi);

  function QuestionReleasesApi(axiosInstance) {
    var _this;

    _classCallCheck(this, QuestionReleasesApi);

    _this = _super.call(this, 'question-releases', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(QuestionReleasesApi, [{
    key: "findManyQuestions",
    value: function findManyQuestions(responseJsonData) {
      try {
        var parsedResponseBody = responseJsonData;

        if (!parsedResponseBody.data) {
          return Result.fail(parsedResponseBody.message);
        }

        var questions = parsedResponseBody.data.map(function (question) {
          switch (question.type) {
            case QuestionType.Essay:
              return EssayQuestion.fromJson(question);

            case QuestionType.SingleChoice:
              return SingleChoiceQuestion.fromJson(question);

            case QuestionType.MultipleChoice:
              return MultipleChoiceQuestion.fromJson(question);

            case QuestionType.FillInBlank:
              return FillInBlankQuestion.fromJson(question);

            case QuestionType.Speaking:
              return SpeakingQuestion.fromJson(question);
          }
        });
        return Result.combineArray(questions);
      } catch (error) {
        return ErrorResultHandler(error);
      }
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var url, jsonResponse, parsedResponseBody, resultCombine;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url);
                _context.next = 4;
                return this.axios.get(url, {
                  params: query
                });

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                resultCombine = parsedResponseBody.data.map(function (question) {
                  switch (question.type) {
                    case QuestionType.Essay:
                      return EssayQuestionRelease.fromJson(question);

                    case QuestionType.SingleChoice:
                      return SingleChoiceQuestionRelease.fromJson(question);

                    case QuestionType.MultipleChoice:
                      return MultipleChoiceQuestionRelease.fromJson(question);

                    case QuestionType.Matching:
                      return MatchingQuestionRelease.fromJson(question);

                    case QuestionType.FillInBlank:
                      return FillInBlankQuestionRelease.fromJson(question);

                    case QuestionType.Speaking:
                      return SpeakingQuestionRelease.fromJson(question);
                  }
                });
                return _context.abrupt("return", Result.combineArray(resultCombine));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }]);

  return QuestionReleasesApi;
}(AxiosApi);